import { render, staticRenderFns } from "./BikeAdd.vue?vue&type=template&id=d2f60256"
import script from "./BikeAdd.vue?vue&type=script&lang=js"
export * from "./BikeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports